export const COMMUNICATION_TOOL_PROCEDURE_TOOLTIPS = Object.freeze({
  tel: Object.freeze([
    "・コールコネクトで時間内は着信を待ってください",
    "・こちらからは発信できません",
    "・カルテ内のチャット欄は使用できません",
  ]),
  line_message: Object.freeze([
    "・予約開始時間に「✋開始挨拶」を押してください",
    "・そのまま相談を開始してください",
  ]),
  line_tel: Object.freeze([
    "・予約開始時間に「✋開始挨拶」を押してください",
    "・通話誘導のため「📞通話誘導」を押してください",
    "・LINE for ビジネスのチャット画面で、着信を待ってください",
    "・通電後、口頭で本人確認を行ってください",
  ]),
  line_video: Object.freeze([
    "・予約開始時間に「✋開始挨拶」を押してください",
    "・通話誘導のため「📞通話誘導」を押してください",
    "・LINE for ビジネスのチャット画面で、着信を待ってください",
    "・通電後、口頭で本人確認を行ってください",
    "・ビデオ切り替えをユーザーに依頼してください",
  ]),
});

export const COMMUNICATION_TOOL_PROCEDURE_TOOLTIP_TITLES = Object.freeze({
  tel: "電話の場合",
  line_message: "LINEメッセージの場合",
  line_tel: "LINE音声通話の場合",
  line_video: "LINEビデオ通話の場合",
});

export const getProcedureTooltipLines = (toolId) => {
  if (!toolId) {
    // toolId未取得時はツールチップを表示しない
    return null;
  }

  // 未知のtoolIdはnullでフォールバックして非表示にする
  return COMMUNICATION_TOOL_PROCEDURE_TOOLTIPS[toolId] ?? null;
};

export const getProcedureTooltipTitle = (toolId) => {
  if (!toolId) {
    return null;
  }

  return COMMUNICATION_TOOL_PROCEDURE_TOOLTIP_TITLES[toolId] ?? null;
};
